import { hc } from 'hono/client';
import { API_BASE } from './rpc';

/**
 * Isolated fetch client specifically for tenant CRM dashboards.
 * Completely decoupled from admin JWT session handling (dark_session)
 * and never triggers admin /login redirects on HTTP 401 challenges.
 */
export const crmFetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  const headers = new Headers(init?.headers);

  // Extract slug from URL or pathname to attach CRM credentials if not already set
  if (typeof window !== 'undefined') {
    let slug = '';
    const pathname = window.location.pathname;
    if (window.location.hostname === 'crm.dark.tel') {
      const parts = pathname.split('/').filter(Boolean);
      if (parts[0] && parts[0] !== 'login') slug = parts[0];
    } else if (pathname.includes('/services/crm/')) {
      const match = pathname.match(/\/services\/crm\/([^/?#]+)/);
      if (match) slug = match[1];
    }

    if (slug) {
      if (!headers.has('x-crm-slug')) {
        headers.set('x-crm-slug', slug);
      }
      if (!headers.has('x-crm-password')) {
        const pw = localStorage.getItem(`crm-pw-${slug}`) ||
                   sessionStorage.getItem(`crm-cdr-pw-${slug}`) ||
                   sessionStorage.getItem(`crm-vm-pw-${slug}`);
        if (pw) headers.set('x-crm-password', pw);
      }
    }
  }

  return fetch(input, { ...init, headers });
};

export const crmClient: any = hc<any>(API_BASE, {
  fetch: crmFetch
});
